import { fetchEventSource } from '@microsoft/fetch-event-source';
import md5 from 'js-md5';

import { getApiUrl } from '@/config/appConfig';
import { PLATFORM, FETCH_SECRET_KEY } from '@/constant/secret';
import { getStorageUser } from '@/utils/storage';

import { covtObjToStr } from './request/axios';
import getDeviceId from '@/utils/deviceFingerprint';

/**
 * 基于 SSE（Server-Sent Events）的流式请求封装，用于 AI 对话等长连接场景。
 * 自动注入鉴权请求头（token、sign、timestamp、noncestr、traceid），超时 300s 后自动中断。
 * 收到 done 标志时提前清除超时计时器；code 30001 时抛出"系统繁忙"错误。
 *
 * @returns 可执行的请求函数，函数上挂载 controller 属性供外部手动中断流
 */
export const fetchSourceApi = async (
  url: string,
  data: {
    [str: string]: any;
    /** 接受 stream 消息的回调函数 */
    onMessage?: (content: string) => void;
    onError?: (err: any) => void;
  }
) => {
  const { onMessage, onError, ...body } = data;
  const timeout = 600000;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);
  const noncestr = Math.random().toString().slice(2, 10);
  // @ts-ignore-next-line
  const traceid = md5(
    new Date().getTime().toString() + Math.random().toString()
  );
  const userInfo: any = getStorageUser() || {};
  const token = userInfo?.token;
  const headers: any = {
    noncestr,
    platform: PLATFORM,
    timestamp: Date.now(),
    traceid,
    version: '1.0.0',
    did: getDeviceId(),
  };
  headers.token = token || '';

  // @ts-ignore-next-line
  headers.sign = md5(
    covtObjToStr(body) + covtObjToStr(headers) + FETCH_SECRET_KEY
  );

  headers['Content-Type'] = 'application/json';
  const fetchRequest = async () => {
    await fetchEventSource(getApiUrl('scrm', url), {
      openWhenHidden: true,
      method: 'post',
      headers,
      body: JSON.stringify(body),
      signal: controller.signal,
      onmessage(ev) {
        if (!ev.data) return;
        const data = JSON.parse(ev.data);
        if (data?.data?.code === 30001) {
          throw new Error('系统繁忙，请稍后再试');
        }
        if (data?.data?.done) {
          clearTimeout(timeoutId);
        }
        onMessage?.(data?.data);
      },
      onerror(err) {
        onError?.(err);
      },
    });
  };
  fetchRequest.controller = controller;
  return fetchRequest;
};
